import React, { useCallback, useEffect, useState } from 'react';
import { FadeIn } from '../components/ui';
import api from '../api/client';

const icons = { booking: '🗓️', assignment: '🧰', salary: '💰', kyc: '✅', promo: '📣', info: '🔔' };

const timeAgo = (d) => {
  const s = Math.floor((Date.now() - new Date(d).getTime()) / 1000);
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
};

export default function Notifications({ onClose }) {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(() => api.get('/notifications')
    .then((d) => setItems(d?.notifications || []))
    .catch(() => {})
    .finally(() => setLoaded(true)), []);

  useEffect(() => { load(); }, [load]);

  const unread = items.filter((n) => !n.read).length;

  const markAll = () => {
    setItems((prev) => prev.map((n) => ({ ...n, read: true })));
    api.put('/notifications/read-all').catch(() => {});
  };

  return (
    <div className="notif">
      <header className="notif__head">
        <button className="topbar__btn" onClick={onClose} aria-label="Close">←</button>
        <div className="grow">
          <div className="notif__title">Notifications</div>
          {unread > 0 && <div className="notif__count">{unread} unread</div>}
        </div>
        <button className="notif__markall" onClick={markAll} disabled={!unread}>Mark all read</button>
      </header>

      <div className="notif__list">
        {items.length === 0 ? (
          <div className="empty">
            <div className="empty__icon">🔔</div>
            <div className="muted" style={{ marginTop: 8 }}>{loaded ? 'No notifications yet' : 'Loading…'}</div>
          </div>
        ) : items.map((n, i) => (
          <FadeIn key={n._id || i} delay={i * 30}>
            <article className={`notif__item ${n.read ? '' : 'notif__item--unread'}`}>
              <span className="notif__icon">{icons[n.type] || icons.info}</span>
              <div className="grow">
                <div className="notif__itemhead">
                  <span className="notif__itemtitle">{n.title}</span>
                  {!n.read && <span className="notif__dot" aria-label="Unread" />}
                </div>
                {n.body ? <p className="notif__body">{n.body}</p> : null}
                <time className="notif__time">{timeAgo(n.createdAt)}</time>
              </div>
            </article>
          </FadeIn>
        ))}
      </div>
    </div>
  );
}
